
import React from 'react';
import { motion } from 'framer-motion';
import { COMPANY_NAME } from '../constants';

const About: React.FC = () => {
  return (
    <section id="about" className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="w-full lg:w-1/2 relative"
          >
            <div className="relative rounded-[1.5rem] md:rounded-[2.5rem] overflow-hidden shadow-2xl border border-slate-50 bg-slate-50">
              <img 
                src="https://imgpx.com/en/XPMaohhkqf0u.png" 
                alt="AVUS Licensed Operational Support"
                className="w-full h-auto block object-contain"
              />
            </div>
            
            <motion.div 
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, type: "spring" }}
              className="absolute -bottom-4 -right-4 md:-bottom-8 md:-right-8 bg-white p-5 md:p-8 rounded-[1.5rem] md:rounded-[2rem] shadow-2xl w-[180px] md:w-[260px] border border-slate-100"
            >
              <div className="flex flex-col items-center text-center">
                <span className="text-2xl md:text-3xl font-black tracking-tighter text-avus-navy mb-3">AVUS</span>
                <div className="w-8 h-0.5 bg-avus-blue mb-3"></div>
                <p className="text-[7px] md:text-[9px] font-bold text-avus-blue uppercase tracking-[0.2em] mb-1">MOCI Licensed</p>
                <p className="text-[10px] md:text-xs font-bold text-avus-navy leading-tight">Operational Excellence</p>
              </div>
            </motion.div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="w-full lg:w-1/2 mt-8 lg:mt-0"
          >
            <h2 className="text-[10px] font-bold text-avus-blue uppercase tracking-[0.3em] mb-3">Strategic Profile</h2>
            <h3 className="text-2xl md:text-4xl font-bold text-avus-navy mb-6 md:mb-8 leading-tight tracking-tight">
              A Partner in Qatar's Regulated Market.
            </h3>
            
            <div className="space-y-4 md:space-y-6 text-sm md:text-base text-slate-600 leading-relaxed font-medium">
              <p>
                <span className="text-avus-navy font-bold">{COMPANY_NAME}</span> is a professional services firm licensed by the Ministry of Commerce and Industry to provide mission-critical business support.
              </p>
              <p>
                We serve as an extension of your back office, managing the administrative complexities of operating in Qatar so that your leadership can prioritize growth.
              </p>
            </div>

            <div className="mt-10 md:mt-12 grid grid-cols-2 gap-6 pt-8 md:pt-10 border-t border-slate-100">
              <div>
                <h4 className="text-base md:text-lg font-bold text-avus-navy mb-1 tracking-tight">Institutional knowledge</h4>
                <p className="text-[10px] md:text-xs text-slate-500 font-medium">Deep regulatory understanding.</p>
              </div>
              <div>
                <h4 className="text-base md:text-lg font-bold text-avus-navy mb-1 tracking-tight">Operational Continuity</h4>
                <p className="text-[10px] md:text-xs text-slate-500 font-medium">Reliable status maintenance.</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
